import React, { useState } from "react";
import MediaQuery from "react-responsive";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
// import Iframe from "react-iframe";
import Gs1 from "./gs1.png"
import VideoPlayer from "react-video-js-player";
import Carags from "./carags.mp4"

const Cgs = ({ukuranP,ukuranH}) => {
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);

	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
				textIndent: "20px",
			}}
			className="container mt-2 mb-3"
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
					fontSize:`${ukuranP}px`
				}}
			>
				Sebuah perusahaan memproduksi sepeda dan skuter dengan menggunakan dua
				mesin. Untuk memproduksi sepeda dibutuhkan waktu 5 jam dengan
				menggunakan mesin 1 dan 2 jam dengan menggunakan mesin 2. Untuk
				memproduksi skuter dibutuhkan waktu 3 jam dengan menggunakan mesin 1 dan
				6 jam dengan menggunakan mesin 2. Kapasitas maksimum mesin 1 150 jam,
				sedangkan kapasitas maksimum mesin 2 180 jam. Keuntungan bersih yang
				diperoleh dari tiap satu unit sepeda adalah Rp400.000,00 dan satu unit
				skuter adalah Rp500.000,00. Tentukan jumlah sepeda dan skuter yang harus
				diproduksi agar diperoleh keuntungan maskimum !
				<div
					style={{
						color: "green",
						display: "flex",
						justifyContent: "space-between",
						width: "10%",
					}}
				>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						<SkipNextIcon />
					</div>
					<p style={{ marginLeft: "22px" }}>
						<strong>
							<u>Jawaban</u>
						</strong>
					</p>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.2s alternate ease infinite",
						}}
					>
						<SkipPreviousIcon />
					</div>
				</div>
				<ol style={{fontSize:`${ukuranP}px`}}>
				<li>Pertama kita buat table terlebih dahulu</li>
					<div className="d-flex justify-content-center">
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div style={{ width: "90%" }}>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "100%",
										textAlign: "center",
									}}
								>
									<tr>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Sepeda
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Skuter
										</th>

										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kapasitas Maksimum
										</th>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Mesin 1
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											5
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											3
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											150
										</td>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Mesin 2
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											2
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											6
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											180
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Keuntungan
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											400.000
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											500.000
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											-
										</td>
									</tr>
								</table>
							</div>
						</MediaQuery>
					</div>
					<div className="d-flex justify-content-center">
						<MediaQuery maxWidth={475}>
							<div style={{ width: "90%" }}>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "100%",
										textAlign: "center",
									}}
								>
									<tr>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Sepeda
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Skuter
										</th>

										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kapasitas Maksimum
										</th>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Mesin 1
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											5
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											3
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											150
										</td>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Mesin 2
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											2
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											6
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											180
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Keuntungan
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											400.000
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											500.000
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											-
										</td>
									</tr>
								</table>
							</div>
						</MediaQuery>
					</div>
				
					<div className="d-flex justify-content-center">
						<button
							className="btn btn-outline-success btn-sm mb-2 mt-2"
							onClick={() => setShow1(true)}
						>
							Lanjut
						</button>
					</div>
{show1?
<>
<li>
Selanjutnya kita memisalkan x banyaknya sepeda dan y banyaknya skuter
</li>
<div className="d-flex justify-content-center">
<button
							className="btn btn-outline-success btn-sm mb-2 mt-2"
							onClick={() => setShow2(true)}
						>
							Lanjut
</button>
</div>
{show2?
<>
<li>Kita buat dalam bentuk pertidaksamaan seperti berikut :</li>
					<p>
						<ul>
							<p>Maka penggunaan mesin 1 :</p>							
							<li>
								<InlineMath math="5x + 3y ≤ 150 " />
							</li>
							<p className="text-center alert alert-warning">Dan kalian sudah mendapatkan satu pertidaksamaan</p>
							<p className="mt-3">Maka penggunaan mesin 2 :</p>
							<li>
								<InlineMath math="2x + 6y ≤ 180 " />
							</li>
							<p className="text-center alert alert-warning">Dan kalian sudah mendapatkan dua pertidaksamaan</p>
						</ul>
					</p>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow3(true)}
>
Lanjut
</button>
</div>
{show3?
<>
<li>
Karena tidak mungkin banyaknya sepeda dan skuter itu negatif, sehingga dapat dituliskan   x ≥ 0   dan  y ≥ 0 .
</li>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow4(true)}
>
Lanjut
</button>
</div>
{show4?
<>
<li>
						Sehingga kita mendapatkan model matematikanya adalah{" "}
						<InlineMath math="5x + 3y ≤ 150 ;" />{" "}
						<InlineMath math="2x + 6y ≤ 180;" /> <InlineMath math="x ≥ 0" />,
						dan <InlineMath math="y ≥ 0" />. 
					</li>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow5(true)}
>
Lanjut
</button>
</div>
{show5?
<>
<li>Sedangkan untuk fungsi objektif adalah <InlineMath math="z = 400.000x + 500.000y " /></li>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow6(true)}
>
Lanjut
</button>
</div>
{show6?
<>
<li>
																		Selanjutnya kita mencari titik potong
																		pada sumbu <InlineMath math="\space x " /> dan pada sumbu <InlineMath math="\space y " />&nbsp; yang ada pada
																		<InlineMath math=" 5x + 3y =150 " />
																		&nbsp; dan tabelnya di bawah ini
</li>
																	<p>
																		<MediaQuery minWidth={476} maxWidth={1824}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>

																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30,0
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						50
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0,50
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	<p>
																		<MediaQuery maxWidth={475}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30,0
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						50
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0,50
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
<p className="text-center"> Maka kita dapatkan :</p>
<div className="d-flex justify-content-center">
Titik Koordinat A = (30, 0)
</div>
<div className="d-flex justify-content-center">
Titik Koordinat B = (0, 50)
</div>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow7(true)}
>
Lanjut
</button>
</div>
{show7?
<>
<li>
Selanjutnya kita mencari titik potong
																		pada sumbu <InlineMath math="\space x " /> dan pada sumbu <InlineMath math="\space y " />&nbsp; yang ada pada
																		<InlineMath math=" 2x + 6y = 180 " />
																		&nbsp; dan tabelnya di bawah ini

</li>
																	<p>
																		<MediaQuery minWidth={476} maxWidth={1824}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>

																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						90
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						90,0
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0,30
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	<p>
																		<MediaQuery maxWidth={475}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						90
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						90,0
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						30
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0,30
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	<p className="text-center"> Maka kita dapatkan :</p>
<div className="d-flex justify-content-center">
Titik Koordinat C = (90, 0)
</div>
<div className="d-flex justify-content-center">
Titik Koordinat D = (0, 30)
</div>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow8(true)}
>
Lanjut
</button>
</div>
{show8?
<>
<li>Selanjutnya coba kamu simak dan pahami video di bawah ini!</li>

<MediaQuery minWidth={476} maxWidth={1824}>
																<VideoPlayer 
																src={Carags}
																width="800"
																height="500"
																/>
																</MediaQuery>
																<MediaQuery maxWidth={475}>
																<VideoPlayer 
																src={Carags}
																width="300"
																height="100"
																/>
																</MediaQuery>
	<div className="text-center"><i><b>Video :</b> menari nilai optimum dengan metode garis selidik.</i></div>
<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow9(true)}
>
Lanjut
</button>
</div>
{show9?
<>
<li>Maka titik koordinat mana yang merupakan nilai maksimum? ya benar titik E</li>
<li>Coba kita tentukan nilai dari titik koordinat E dengan menggunakan eliminasi</li>
<div className="d-flex justify-content-center">
																																<MediaQuery
																																	minWidth={476}
																																	maxWidth={
																																		1824
																																	}
																																>
																																	<TransformWrapper
																																		defaultScale={
																																			1
																																		}
																																	>
																																		<TransformComponent>
																																			<img
																																				src={
																																					Gs1
																																				}
																																				alt="Gs1"
																																			/>
																																		</TransformComponent>
																																	</TransformWrapper>
																																</MediaQuery>
</div>
<MediaQuery
																																maxWidth={475}
																															>
																																<TransformWrapper
																																	defaultScale={
																																		1
																																	}
																																>
																																	<TransformComponent>
																																		<img
																																			style={{
																																				height:
																																					"200px",
																																				width:
																																					"200px",
																																			}}
																																			src={Gs1}
																																			alt="Gs1"
																																		/>
																																	</TransformComponent>
																																</TransformWrapper>
</MediaQuery>
<p>Maka nilai <InlineMath math="x = 15"/></p>
<li>
																																Selanjutnya kita
																																mencari nilai{" "}
																																<InlineMath math=" y " />{" "}
																																dengan
																																mensubstitusikan
																																nilai{" "}
																																<InlineMath math=" x " />
																															</li>

																															<li>
																																Selanjutnya
																																substitusikan&nbsp;
																																<InlineMath math=" x = 15" />&nbsp;
																																ke salah satu
																																persamaan.
																																Disini kita
																																memakai&nbsp;
																																<InlineMath math="5x + 3y = 150" />
																															</li>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="5(15) + 3y = 150" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math=" 75 + 3y = 150" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="3y = 150 - 75 " />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="3y = 75 " />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="y = 25 " />
																															</div>
																													
					<li>
						Untuk memastikan nilai maksimumnya. Masukkan <b>titik E =(15,25)</b>
						kedalam fungsi objektif.
					</li>
					<div className="d-flex justify-content-center">
					<table
																																			className="table"
																																			style={{
																																				border:
																																					"2px solid green",
																																				borderCollapse:
																																					"collapse",
																																				width:
																																					"100%",
																																				textAlign:
																																					"center",
																																			}}
																																		>
																																			<tr>
																																				<th
																																					scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}
																																				>
																																					Titik
																																					koordinat
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math="z = 400000x + 500000y" />
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					Hasil
																																				</th>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					(0
																																					, 0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400000(0) + 500000(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																				0
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					A
																																					(30,0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400000(30) + 500000(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					12.000.000
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					D
																																					(0,30)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400000(0) + 500000(30)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					15.000.000
																																				</td>
																																			</tr>																																			
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					E (15
																																					, 25)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400000(15) + 500000(25)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																				18.500.000
																																				</td>
																																			</tr>
					</table>
					</div>
					<div className="d-flex justify-content-center">
<button
className="btn btn-outline-success btn-sm mb-2 mt-2"
onClick={() => setShow10(true)}
>
Lanjut
</button>
</div>
{show10?
<>
					<li>
						Jadi, biaya <b>maksimum</b> yang dibutuhkan oleh perusahaan tersebut
						adalah <InlineMath math=" Rp18.500.000,00 " />.
					</li>
</>
:null}				
</>
:null}
</>
:null}
</>
:null}					
</>
:null}
</>
:null}
</>
:null}				
</>
:null}						
</>
:null}
</>
:null}
				
				</ol>
			</div>
		</div>
	);
};

export default Cgs;
